export default "__VITE_ASSET__6557ac0a__"